import { Injectable } from '@angular/core';
import { createClient } from 'contentful';
import { BehaviorSubject, distinctUntilChanged, from } from 'rxjs';
import { environment } from '../../environments';
// import { TypeJobListingFields } from './content-types';

@Injectable({
  providedIn: 'root'
})
export class ContentService {

  private filtersSubject = new BehaviorSubject<any>(null)
  public filters = this.filtersSubject.asObservable().pipe(distinctUntilChanged())
  private filtersLocal: any[]
  
  client = createClient({
    space: environment.contentful.spaceId,
    accessToken: environment.contentful.accessToken,
    environment: environment.contentful.environment
  })


  constructor() {}

  getProjects(query?: object){
    // console.log('getProjects', query)
    return from(
      this.client.getEntries<any>(Object.assign({
      content_type: 'project'
      }, query))
    );
  }

  getProjectBySlug(slug: string) {
    let projects = this.getProjectsBySlug(slug)
    console.log('TODO: gpbs', slug, projects)
    // return projects[0]
  }
  getProjectsBySlug(slug: string, query?: any){
    return from(
      this.client.getEntries<any>(Object.assign({
      content_type: 'project',
      'fields.slug': slug,
      }, query))
    )
  }

  getPage(query?: object){
    // console.log('GET PAGE', query)
    return from(
      this.client.getEntries<any>(Object.assign({
        //      this.client.getEntries<TypeJobListingFields>(Object.assign({
        content_type: 'homepage', // NOT A TYPO; Page is locked with ID 'homepage'
        include: 10
      }, query))
    )
  }
  
  getMainNavItems(query?: object) {
    return from(
      this.client.getEntries<any>(Object.assign({
        //      this.client.getEntries<TypeJobListingFields>(Object.assign({
        content_type: 'menu',
        'fields.slug': 'main-nav',
      }, query))
    )
  }

  getFilters(query?: object){
    return from(
      this.client.getEntries<any>(Object.assign({
      //      this.client.getEntries<TypeJobListingFields>(Object.assign({
      content_type: 'filter'
      }, query))
    );
  }

  getMetadata(query?: object){
    // console.log('getMetadata', query)
    return from(
      this.client.getEntries<any>(Object.assign({
      content_type: 'metadata'
      }, query))
    );
  }

  getTags(query?: object) {
    return from(
      this.client.getTags()
      .then((response) => {
        // console.log('CHECK getTags:', response.items)
        return response
      })
      .catch(console.error)
    )
  }
}